import {
  EditableCellContainer,
  UpdateQuantityModal,
  VerticalList,
} from "./BoardInventoryStyles";
import Icon from "../../common/Icon";
import React, { SyntheticEvent, useState } from "react";
import { PartWithInventory } from "../../../utils/hooks/inventory/boardInventory";
import NumberInput from "../../common/NumberInput";
import useUpdateRequiredAmountForProject from "../../../utils/hooks/inventory/updateRequiredAmountForProject";
import ModalContentWithCloseButton from "../../common/ModalContentWithCloseButton";
import Modal from "../../common/Modal";
import Button from "../../common/Button";
import { EditButton } from "../../ReviewBoardFlow/BillOfMaterials/ElementsTable/ElementsTableStyles";
import { ButtonTypes } from "../../common/Button/constants";
import { InputLabel, Pill } from "../../../constants/Styles";

export default function AllocatedQuantityCell({
  part,
  updating = false,
}: {
  part: PartWithInventory;
  // The shipment is being reprocessed, so the required amount may be about
  // to change
  updating?: boolean;
}) {
  const [editing, setEditing] = useState<boolean>(false);
  const [quantityNeeded, setQuantityNeeded] = useState<number>(
    part.required_amount,
  );

  const onSuccessfulUpdate = () => {
    setEditing(false);
  };
  const { updateQuantity, loading } =
    useUpdateRequiredAmountForProject(onSuccessfulUpdate);

  const closeModal = () => {
    setEditing(false);
  };

  const updateValue = (event: SyntheticEvent) => {
    event.preventDefault();
    setEditing(false);
    if (part.part.id) {
      updateQuantity(part.part.id, quantityNeeded);
    }
  };

  return (
    <EditableCellContainer>
      <VerticalList>
        <InputLabel>Required amount: </InputLabel>
        {updating ? <Pill width={"5rem"} /> : <div>{part.required_amount}</div>}
      </VerticalList>
      <EditButton
        onClick={loading || updating ? undefined : () => setEditing(true)}
        disabled={loading || updating}
      >
        <Icon src="/icons/pencil.svg" alt="edit" />
      </EditButton>
      <Modal isOpen={editing} onRequestClose={closeModal}>
        <ModalContentWithCloseButton closeModal={closeModal}>
          <form onSubmit={updateValue}>
            <UpdateQuantityModal>
              <NumberInput
                value={quantityNeeded}
                onChange={setQuantityNeeded}
                disabled={loading}
                min={0}
                autoFocus
              />
              <Button
                label={"Update required amount"}
                type={ButtonTypes.SUBMIT}
              />
            </UpdateQuantityModal>
          </form>
        </ModalContentWithCloseButton>
      </Modal>
    </EditableCellContainer>
  );
}
